"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const settlementManageState_1 = require("@/room/settlement_manage/settlementManageState");
const react_i18next_1 = require("react-i18next");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
function default_1() {
    const { id: roomId, settlement_list } = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementDetailsDataState);
    const noListAvailable = !Boolean(settlement_list.length);
    const { t } = (0, react_i18next_1.useTranslation)();
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const settlementList = [...settlement_list].sort((a, b) => {
        // ? 정산 완료 안된 건들(!is_processed && !is_approved) 먼저 최신날짜 순으로 정렬,
        // ? 이어서 나머지 건들 최신 날짜 순으로 정렬
        if (!a.is_processed && !a.is_approved) {
            if (!b.is_processed && !b.is_approved) {
                return new Date(b.upd_time).getTime() - new Date(a.upd_time).getTime();
            }
            return -1;
        }
        else if (!b.is_processed && !b.is_approved) {
            return 1;
        }
        return new Date(b.upd_time).getTime() - new Date(a.upd_time).getTime();
    });
    if (!roomId)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    if (noListAvailable)
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body1 gray-80", css: { flex: 1, paddingTop: maxWidth768 ? '140px' : '160px', textAlign: 'center' } }, { children: t('아직 접수된 내역이 없어요.') })));
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            rowGap: maxWidth768 ? '10px' : '16px',
            paddingBottom: '148px',
        } }, { children: settlementList.map((listItem, index) => ((0, jsx_runtime_1.jsx)(_1.SettlementListItem, { listItem: listItem }, `settlement_list_item_${listItem.id}_${index}`))) })));
}
exports.default = default_1;
